define('modules/campaigns/modal/play_selected_modal_view',[
  'backbone',
  'jquery',
  '_',
  'text!./play_selected_modal_template.html'
], function (Backbone, $, _,
             modal_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.render();
    },

    tagName: 'div',
    className: 'play-selected-modal',
    template: _.template(modal_template),

    events: {
      'click .js-confirm-button': 'confirmPlaySelected',
    },

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    confirmPlaySelected: function () {
      Backbone.trigger('campaigns:modifystatus', 'play');
      this.trigger('close');
    },

    remove: function () {
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

